'use client';
import React from 'react';

export default function FreeStreamSection() {
  return (
    <section className="py-16 px-4 sm:px-6">
      <div className="max-w-7xl mx-auto">
        <div className="section-card p-8 sm:p-12 flex flex-col lg:flex-row items-center gap-10">
          {/* Left content */}
          <div className="lg:w-1/2">
            {/* Freestream badge */}
            <div className="inline-flex items-center gap-2 bg-gradient-to-r from-[#ff6c01] via-[#ffab01] to-[#ffed01] rounded-full px-4 py-1.5 mb-6">
              <svg className="w-4 h-4 text-black" fill="currentColor" viewBox="0 0 20 20">
                <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
              </svg>
              <span className="text-black font-black text-sm">freestream</span>
            </div>

            <h2 className="text-[28px] sm:text-[32px] font-black text-white mb-4 leading-tight">
              Watch TV,{' '}
              <span className="text-gradient-orange">100% Free</span>
            </h2>
            <p className="text-[#c3c3c3] text-base leading-relaxed mb-2">
              Get 600+ free live TV channels plus free Cloud DVR and win cash! Sling Consonantal Digital&apos;s Freestream is the only free streaming service that lets you do all that.
            </p>
            <p className="text-[#979797] text-sm mb-6">
              <a href="#" className="text-[#00b9ff] hover:underline">Learn more</a> about Freestream.
            </p>
            <a href="#" className="btn-outline inline-flex">
              Stream Free
            </a>
          </div>

          {/* Right - Video/Preview placeholder */}
          <div className="lg:w-1/2 w-full">
            <div className="relative rounded-xl overflow-hidden bg-[#0d0d16] border border-white/10 aspect-video flex items-center justify-center">
              {/* Simulated TV screen */}
              <div className="absolute inset-0 bg-gradient-to-br from-[#20222f] to-[#0d0d16]" />
              <div className="relative z-10 text-center">
                <div className="w-16 h-16 rounded-full bg-[#00b9ff]/20 border-2 border-[#00b9ff] flex items-center justify-center mx-auto mb-4 cursor-pointer hover:bg-[#00b9ff]/30 transition-all">
                  <svg className="w-7 h-7 text-[#00b9ff] ml-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zM9.555 7.168A1 1 0 008 8v4a1 1 0 001.555.832l3-2a1 1 0 000-1.664l-3-2z" clipRule="evenodd" />
                  </svg>
                </div>
                <p className="text-white font-bold text-sm">Watch 600+ Free Channels</p>
                <p className="text-[#979797] text-xs mt-1">No credit card required</p>
              </div>
              {/* Decorative channel pills */}
              <div className="absolute top-4 left-4 flex gap-2">
                <span className="bg-[#cc0000] text-white text-[10px] font-black px-2 py-0.5 rounded">LIVE</span>
                <span className="bg-[#20222f] text-[#00b9ff] text-[10px] font-bold px-2 py-0.5 rounded border border-[#00b9ff]/30">FREE</span>
              </div>
              <div className="absolute bottom-4 left-4 right-4">
                <div className="bg-[#20222f]/80 rounded-lg p-3 flex items-center gap-3">
                  <div className="w-8 h-8 rounded bg-[#cc0000] flex items-center justify-center text-white text-[10px] font-black">NEWS</div>
                  <div>
                    <div className="text-white text-xs font-bold">Breaking News Live</div>
                    <div className="text-[#979797] text-[10px]">Consonantal News Network • LIVE</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
